import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import { clouds } from "../../../../utils/icons";
import AppWizard from "../../../../shared/appWizard/appWizard";
import AwsIntegrationConfiguration from "./awsIntegrationConfiguration";
import AwsFinalInstructions from "./awsFinalInstructions";
import { getInstructionsCode } from "../../../../redux/actions/keyPairsActions";
import regionsOptions from "../../../../consts/regions";

import "./awsIntegration.scss";

const AwsIntegration = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [wizardState, setWizardState] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [previousDisabled, setPreviousDisabled] = useState(false);
  const [isProd, setIsProd] = useState(false);
  const [isEventDriven, setIsEventDriven] = useState(true);
  const [iacAutoDiscovery, setIacAutoDiscovery] = useState(true);
  const [regions, setRegions] = useState(_.keys(regionsOptions));
  const [bucketsByRegionMap, setBucketsByRegionMap] = useState({});
  const [disableSubmit, setDisableSubmit] = useState(false);

  const externalId = useSelector((state) => state.integrationsReducer.aws.externalId);

  const themeDark = useSelector((state) => state.userPreferencesReducer.themeDark);

  useEffect(() => {
    setPreviousDisabled(false);
  }, []);

  useEffect(() => {
    if (isEventDriven && _.isEmpty(regions)) {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
  }, [regions, isEventDriven]);

  const configWizard = [
    {
      step_title: "Configuration",
      step_description: "Modify default configuration values",
      content_title: "Terraform Provider Configuration",
      content: (
        <AwsIntegrationConfiguration
          wizardState={wizardState}
          setWizardState={setWizardState}
          setSubmitDisabled={setSubmitDisabled}
          isProd={isProd}
          handelSetIsProd={() => setIsProd(!isProd)}
          isEventDriven={isEventDriven}
          iacAutoDiscovery={iacAutoDiscovery}
          handelSetIsEventDriven={() => setIsEventDriven(!isEventDriven)}
          handleIacAutoDiscovery={() => setIacAutoDiscovery(!iacAutoDiscovery)}
          setLabels={(regions) => setRegions(regions)}
          regions={regions}
          disableSubmit={disableSubmit}
          bucketsByRegionMap={bucketsByRegionMap}
          setBucketsByRegionMap={setBucketsByRegionMap}
        />
      ),
      valid: true,
      beforeNextStep: async () => {
        setLoadingSubmit(true);
        setPreviousDisabled(true);
        const data = await dispatch(getInstructionsCode("aws", { name: wizardState?.name, isProd, externalId, isIacAutoDiscoverDisabled: !iacAutoDiscovery, isEventDriven, regions: isEventDriven ? regions: [], bucketsByRegionMap }));
        setWizardState({ ...wizardState, code: data?.code });
        setLoadingSubmit(false);
        if (_.isEmpty(data?.code)) {
          throw new Error("Failed to get instructions code. Please try again");
        }
      },
    },
    {
      step_title: "Completion",
      step_description: "Final Instructions",
      content_title: "Terraform Provider Configuration",
      content: (
        <AwsFinalInstructions
          wizardState={wizardState}
          setSubmitDisabled={setSubmitDisabled}
        />
      ),
      valid: true,
    },
  ];

  return (
    <div className="AwsIntegration">
      <AppWizard
        iconSrc={clouds("aws", themeDark)}
        iconStyle={{ height: "35px", transform: "translateY(2px)" }}
        loadingSubmit={loadingSubmit}
        configWizard={configWizard}
        handleClose={() => history.goBack()}
        submitDisabled={submitDisabled}
        setSubmitDisabled={setSubmitDisabled}
        handleSubmit={() => history.push("/integrations")}
        prevDisabled={previousDisabled}
      />
    </div>
  );
};

export default AwsIntegration;
